import { useEffect, useState } from 'react';
import { getMatchScreenKey } from '@/utils/style/screen';
/**
 * 現状の画面幅に一致する breakpoint 取得(リサイズ対応有)
 */
export const useMatchMedia = () => {
    const [screenKey, changeScreenKey] = useState(() => getMatchScreenKey());
    // リサイズ時
    useEffect(() => {
        const onResize = () => {
            const key = getMatchScreenKey();
            changeScreenKey(key);
        };
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        screenKey,
    };
};
